import api from "../interceptor/interceptor";

const TripService = {
    async getTrips(startDate, endDate, pNumber = 1, pSize = 10) {
        try {
            const response = await api.get(
                `/trips?startDate=${startDate}&endDate=${endDate}&pSize=${pSize}&pNumber=${pNumber}`
            )
            return response.data.trips;
        } catch (e) {
            console.log(e)
            return {
                message: e.response.data.errors
            }
        }
    },
    async getTripCounts(startDate, endDate) {
        try {
            const response = await api.get(
                `/trips/info?startDate=${startDate}&endDate=${endDate}`
            )
            return response.data;

        } catch (e) {
            return {
                message: e.response.data.errors
            }
        }
    },
    async getTripAlerts(startDate, endDate) {
        try {
            const vehicles= await api.get(`/vehicles`)
            const vehicleList = vehicles.data.vehicles.map((vehicle) => vehicle?._id);

            const response =  await api.post(`/trips/fleet/analytics`,
                {
                    "fromdate": startDate,
                    "todate": endDate,
                    "vehicle": vehicleList
                },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            )
            return response.data.data;
        } catch (e) {
            return {
                message: e.response.data.errors
            }
        }
    }
}


export default TripService;
